import { createContext, useContext, useEffect, useState } from "react";

const LangContext = createContext(null);

export const LANGS = {
  ar: { label: "AR", dir: "rtl", locale: "ar" },
  en: { label: "EN", dir: "ltr", locale: "en" },
};

export function LangProvider({ children }) {
  const [lang, setLang] = useState(
    () => localStorage.getItem("jisr_lang") || "ar"
  );

  useEffect(() => {
    document.documentElement.setAttribute("dir", LANGS[lang]?.dir || "rtl");
    document.documentElement.setAttribute("lang", lang);
    localStorage.setItem("jisr_lang", lang);
  }, [lang]);

  const toggle = () => setLang((l) => (l === "ar" ? "en" : "ar"));

  return (
    <LangContext.Provider value={{ lang, toggle, label: LANGS[lang]?.label }}>
      {children}
    </LangContext.Provider>
  );
}

export function useLang() {
  return useContext(LangContext);
}
